var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('router-view',{staticClass:"app-content",attrs:{"login":_vm.login},on:{"refreshLoginData":_vm.refreshLoginData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }